import React, { Fragment, useState } from 'react';
import { Col, Container, Row, } from 'reactstrap';
import { TabMenu } from 'primereact/tabmenu';
import { IndexIndicationsPatients } from './IndexIndicationsPatients';
import { IndexIndicationsLaboratorys } from './IndexIndicationsLaboratorys';

export const IndexIndications = (props) => {
   const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        { label: 'Indicaciones de Pacientes' },
        { label: 'Indicaciones de laboratorio' }
    ];
     return (
        <Fragment>
            <Container fluid={true}>
                <div className='container-global-zoom'>
                    <Row>
                        <Col sm="12">
                            <div>
                                <TabMenu 
                                    model={items} 
                                    activeIndex={activeIndex} 
                                    onTabChange={(e) => setActiveIndex(e.index)}
                                    className="custom-tabmenu-blue-report"
                                />
                            </div>
                            <div style={{ marginTop: "1rem" }}>
                                <div style={{ display: activeIndex === 0 ? "block" : "none" }}>
                                    <IndexIndicationsPatients {...props} />
                                </div>
                                <div style={{ display: activeIndex === 1 ? "block" : "none" }}>
                                    <IndexIndicationsLaboratorys {...{ ...props, }} />
                                </div>
                            </div>
                        </Col>
                </Row>

                </div>
                
            </Container>
        </Fragment >
    )
}
